module.exports = "<!-- * CUSTOM-NAV-LINKS * -->\n<router-outlet></router-outlet>"